import { FC, useContext, useState } from "react";
import { Accordion } from "@app/shared/Accordion";
import { AccordionContainer } from "@app/shared/AccordionContainer";
import { GapsWidget } from "@app/network-portfolio-management/components/widgets/GapsWidget";
import { ProjectCountWidget } from "@app/network-portfolio-management/components/widgets/ProjectCountWidget";
import { BaseContext } from "@app/network-portfolio-management/contexts/BaseContext";
import { NetworkPortfolioManagementResourceView } from "@app/network-portfolio-management/interfaces";
import { useNPMView } from "@app/network-portfolio-management/hooks/useNPMView";

export const KeyMetrics: FC = () => {
  const { projectIds } = useContext(BaseContext);
  const isArchived = useNPMView().getCurrentNpmView() === NetworkPortfolioManagementResourceView.Archived;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <AccordionContainer className={isOpen ? "network-portfolio-management-key-metrics-sticky" : undefined}>
      <Accordion
        defaultOpen
        testId="network-portfolio-management-key-metrics-accordion"
        title="Key Metrics"
        variant="flat"
        onPanelDidOpen={() => setIsOpen(true)}
        onPanelDidClose={() => setIsOpen(false)}
      >
        <div className="network-portfolio-management-key-metrics-grid">
          <ProjectCountWidget projectIds={projectIds} />
          {!isArchived && <GapsWidget projectIds={projectIds} />}
        </div>
      </Accordion>
    </AccordionContainer>
  );
};
